<div class="provider-section-grid" [formGroup]="formGroup">
  <div class="provider-section-header">
    <h5 class="section-title">Provider Details</h5>
  </div>
  <div class="provider-section-field">
    <div class="user-record-field-wrapper">
      <label for="providerId" class="field-label">Provider ID</label>
      <mat-form-field class="provider-fields">
        <input
          id="providerId"
          matInput
          [disabled]="showReviewStatus ? true : false"
          type="text"
          placeholder="Provider ID"
          class="user-record-field-input"
          [value]="providerData?.recordNumber || 'N/A'" />
      </mat-form-field>
    </div>
  </div>
  <div class="provider-section-field">
    <div class="user-record-field-wrapper user-record-dropdown-wrapper">
      <label for="services" class="field-label">Services</label>
      <mat-form-field class="provider-fields">
        <mat-select
          id="services"
          [multiple]="true"
          [disabled]="showReviewStatus ? true : false"
          [value]="providerData?.subjects || []"
          placeholder="Select Subservice">
          @for (service of subServices; track service) {
            <mat-option [value]="service.name">
              {{ service.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div class="provider-section-field">
    <div class="user-record-field-wrapper">
      <label for="employees" class="field-label">Employees</label>
      <mat-form-field class="provider-fields">
        <input
          id="employees"
          matInput
          [disabled]="showReviewStatus ? true : false"
          type="text"
          placeholder="Therapy (0), Tutoring (0)"
          class="user-record-field-input"
          [value]="employeesDisplay()" />
      </mat-form-field>
    </div>
  </div>
  <div class="provider-section-field"></div>
</div>
